import * as React from "react"
import { SvgFilterFunnel02 } from "@digits-shared/components/SVGIcons/line/FilterFunnel02.svg"
import { SvgSwitchVertical01 } from "@digits-shared/components/SVGIcons/line/SwitchVertical01.svg"
import { SvgFilterFunnel02Solid } from "@digits-shared/components/SVGIcons/solid/FilterFunnel02Solid.svg"
import { useDimensionDisplayOptionGroup } from "src/frontend/components/OS/Shared/DisplayOptions/DimensionDisplayOptionGroupContext"
import { useDimensionSortElements } from "src/frontend/components/OS/Shared/DisplayOptions/displayOptionsHooks"
import { DisplayOptionsSection } from "src/frontend/components/OS/Shared/DisplayOptions/DisplayOptionsSection"
import { FilterColumn } from "src/frontend/components/OS/Shared/DisplayOptions/Filters/FilterColumn"
import { SortColumn } from "src/frontend/components/OS/Shared/DisplayOptions/Sorts/SortColumn"
import { FilterByDimensionActivity } from "src/shared/components/Filters/FilterByDimensionActivity"
import { TransactionFilterType } from "src/shared/components/Filters/types"

/*
  COMPONENTS
*/

export const DimensionDisplayOptionGroup: React.FC<{ className?: string }> = ({ className }) => {
  const { clearOnlyFilters, currentFilterURLKeysCount, sortBy, sortDirection, dimensionActivity } =
    useDimensionDisplayOptionGroup()
  const dimensions = useDimensionSortElements(sortBy, sortDirection)

  return (
    <>
      <DisplayOptionsSection
        title="Filter"
        activeCount={currentFilterURLKeysCount}
        IconElement={SvgFilterFunnel02}
        ActiveIconElement={SvgFilterFunnel02Solid}
      >
        <FilterColumn
          defaultAccordionOpen={TransactionFilterType.DimensionActivity}
          onResetClick={clearOnlyFilters}
          currentFiltersCount={currentFilterURLKeysCount}
        >
          <FilterByDimensionActivity
            selectedActivity={dimensionActivity.get()}
            toggleActivity={dimensionActivity.set}
          />
        </FilterColumn>
      </DisplayOptionsSection>
      <DisplayOptionsSection title="Sort" IconElement={SvgSwitchVertical01}>
        <SortColumn dimensions={dimensions} sortDirection={sortDirection} />
      </DisplayOptionsSection>
    </>
  )
}
